import { CreateManyToMany, FieldType, FormField } from "../commons";

export const ConfigurationTableList = [
  {
    name: "UserAccounts",
    displayName: "Users",
    description:
      "En esta vista se guardan los nombres de los usuarios, su información personal así como sus contraseñas.",
    endpoint: "UserAccounts",
    idName: "id",
    showInMenu: true,
    fieldsToShow: ["username", "name", "lastName"],
    customCreateEndpoint: "UserAccounts/signup",
    listTitleLabel: "label_administration_UserAccounts_list_displayName",
    listDescriptionLabel: "label_administration_UserAccounts_list_description",
    fields: [
      new FormField(
        "username",
        "",
        FieldType.INPUT,
        null,
        null,
        null,
        null,
        ["email", "required", "not_duplicated|UserAccounts|username"],
        null,
        null,
        [
          {
            rule: "setFieldValue",
            fieldName: "email",
          },
        ]
      ),
      new FormField("name", "", FieldType.INPUT, null, null, null, null, [
        "required",
      ]),
      new FormField("lastName", "", FieldType.INPUT, null, null, null, null, [
        "required",
      ]),
      new FormField(
        "gender",
        "",
        FieldType.SELECT_LIST,
        undefined,
        undefined,
        undefined,
        [
          {
            value: "male",
            text: "male",
          },
          { value: "female", text: "female" },
        ],
        ["required"]
      ),
      new FormField("phone", "", FieldType.INPUT),
      new FormField("position", "", FieldType.INPUT),
      new FormField("password", "", FieldType.INPUT, null, null, null, null, [
        "required",
      ], null, null, null,true),
    ],
    ManyToManyRelationships: [
      new CreateManyToMany(
        "AccountRoles",
        "id",
        "name",
        "UserAccountRoles",
        "userAccountId",
        "accountRoleId"
      ),
    ],
  },
  {
    name: "AccountRoles",
    displayName: "Roles",
    showInMenu: true,
    description:
      "Los roles de usuario permiten limitar el acceso y los permisos que tengan los usuarios sobre las empresas y las funcionalidades de la aplicación",
    endpoint: "AccountRoles",
    idName: "id",
    fieldsToShow: ["name", "accountRoleTemplateId"],
    fields: [
      new FormField("name", "", FieldType.INPUT, null, null, null, null, [
        "required",
        "not_duplicated|AccountRoles|name",
      ]),
      new FormField(
        "accountRoleTemplateId",
        "",
        FieldType.SELECT,
        "AccountRoleTemplates",
        "id",
        "name",
        [],
        ["required"]
      ),
    ],
    ManyToManyRelationships: [
      new CreateManyToMany(
        "UserAccounts",
        "id",
        "name",
        "UserAccountRoles",
        "accountRoleId",
        "userAccountId","name",null,[{field:'name'}, {field:'lastName', separator:'<br>'}, {field:'email', separator:'<br>'}, {field:'position', separator:'<br>'}]
      ),
    ],
    extraSections: ["ruled-by"],
  },
  {
    name: "Country",
    endpoint: "Countries",
    idName: "id",
    displayName: "Country",
    fieldsToShow: ["country"],
    showInMenu: true,
    fields: [new FormField("country", "", FieldType.INPUT)],
    ManyToManyRelationships: [
      new CreateManyToMany(
        "Regions",
        "id",
        "region",
        "CountryRegions",
        "countryId",
        "regionId"
      ),
    ],
  },
  {
    name: "Region",
    endpoint: "Regions",
    idName: "id",
    displayName: "Region",
    fieldsToShow: ["region"],
    showInMenu: true,
    fields: [new FormField("region", "", FieldType.INPUT)],
    ManyToManyRelationships: [
      new CreateManyToMany(
        "Countries",
        "id",
        "country",
        "CountryRegions",
        "regionId",
        "countryId"
      ),
    ],
  },
  {
    name: "AccessControl",
    endpoint: "AccessControls",
    idName: "id",
    fieldsToShow: ["regionId", "tagId", "accountRoleId", "permissionsId"],
    fields: [
      new FormField(
        "regionId",
        "",
        FieldType.SELECT,
        "Regions",
        "id",
        "region"
      ),
      new FormField("tagId", "", FieldType.SELECT, "Tags", "id", "name"),
      new FormField(
        "accountRoleId",
        "",
        FieldType.SELECT,
        "AccountRoles",
        "id",
        "name"
      ),
      new FormField(
        "permissionsId",
        "",
        FieldType.SELECT,
        "Permissions",
        "id",
        "name"
      ),
    ],
    ManyToManyRelationships: [],
  },
  {
    name: "Business",
    endpoint: "Businesses",
    labelPrefix:'label_',
    idName: "id",
    showInMenu: true,
    displayName: "Company",
    sortBy: "selfAssessment_general_business_companyName",
    fieldsToShow: ["selfAssessment_general_business_companyName", "selfAssessment_general_business_entityType","selfAssessment_general_business_organizationType","selfAssessment_general_business_locationCountry_id"],
    ManyToManyRelationships: [
      new CreateManyToMany(
        "Tags",
        "id",
        "name",
        "BusinessTags",
        "businessId",
        "tagId"
      ),
    ],
    fields: [
      new FormField(
        "selfAssessment_general_business_companyName",
        "",
        FieldType.INPUT,
        null,
        null,
        null,
        null,
        [
          "check_company_exists",
          "required",
          "not_duplicated|Businesses|selfAssessment_general_business_companyName",
        ],
        null,
        "label_selfAssessment_general_business_title"
      ),
      new FormField(
        "selfAssessment_general_business_taxIdentificationNumber",
        "",
        FieldType.INPUT,
        null,
        null,
        null,
        null,
        null,
        null,
        "label_selfAssessment_general_business_title"
      ),
      new FormField(
        "selfAssessment_general_business_entityType",
        "",
        FieldType.SELECT,
        null,
        null,
        null,
        null,
        null,
        "optionList_selfAssessment_general_business_entityType",
        "label_selfAssessment_general_business_title"
      ),
      new FormField(
        "selfAssessment_general_business_organizationType",
        "",
        FieldType.SELECT,
        null,
        null,
        null,
        null,
        null,
        "optionList_selfAssessment_general_business_organizationType",
        "label_selfAssessment_general_business_title"
      ),
      new FormField(
        "selfAssessment_general_business_locationCountry_id",
        "",
        FieldType.SELECT,
        "Countries",
        "country",
        "country",
        [],
        ["required"],
        null,
        "label_selfAssessment_general_business_title",
        [
          {
            rule: "setSelectFieldText",
            fieldName: "selfAssessment_general_business_locationCountry",
          },
        ]
      ),
      new FormField(
        "selfAssessment_general_business_certificationStatus",
        "",
        FieldType.SELECT,
        null,
        null,
        null,
        null,
        null,
        "optionList_selfAssessment_general_business_certificationStatus",
        "label_selfAssessment_general_business_title"
      ),
      new FormField(
        "selfAssessment_general_business_wepsSignatory",
        "",
        FieldType.SELECT,
        null,
        null,
        null,
        null,
        null,
        "optionList_selfAssessment_general_business_wepsSignatory",
        "label_selfAssessment_general_business_title"
      ),
      new FormField(
        "selfAssessment_general_business_unGlobalCompactMember",
        "",
        FieldType.SELECT,
        null,
        null,
        null,
        null,
        null,
        "optionList_selfAssessment_general_business_unGlobalCompactMember",
        "label_selfAssessment_general_business_title"
      ),
      /* new FormField('selfAssessment_general_classification_sector_id', '', FieldType.SELECT, null, null, null, null, null, 'optionList_selfAssessment_general_classification_sector', 'label_selfAssessment_general_business_entityType'),
      new FormField('selfAssessment_general_classification_activityAggregated_id', '', FieldType.SELECT, null, null, null, null, null, 'optionList_selfAssessment_general_classification_activityAggregated', 'label_selfAssessment_general_business_entityType'),
      new FormField('selfAssessment_general_classification_activityDetailed_id', '', FieldType.SELECT, null, null, null, null, null, 'optionList_selfAssessment_general_classification_activityDetailed', 'label_selfAssessment_general_business_entityType'),*/
      /* new FormField('selfAssessment_general_classification_market', '', FieldType.CHECKBOX, null, null, null, [
        {
          label: 'selfAssessment_general_classification_market_international',
          field: 'selfAssessment_general_classification_market_international'
        },
        {
          label: 'selfAssessment_general_classification_market_national',
          field: 'selfAssessment_general_classification_market_national'
        },
        {
          label: 'selfAssessment_general_classification_market_local',
          field: 'selfAssessment_general_classification_market_local'
        }
      ], null, null, 'label_selfAssessment_general_business_entityType'),*/
      new FormField(
        "selfAssessment_general_business_address",
        "",
        FieldType.INPUT,
        null,
        null,
        null,
        null,
        null,
        null,
        "label_selfAssessment_general_business_other_fields"
      ),
      new FormField(
        "selfAssessment_general_business_email",
        "",
        FieldType.INPUT,
        null,
        null,
        null,
        null,
        ["email", "required"],
        null,
        "label_selfAssessment_general_business_other_fields"
      ),
      new FormField(
        "selfAssessment_general_business_cellphone",
        "",
        FieldType.INPUT,
        null,
        null,
        null,
        null,
        null,
        null,
        "label_selfAssessment_general_business_other_fields"
      ),
    ],
    fieldCategories: [
      "label_selfAssessment_general_business_title",
      /* 'label_selfAssessment_general_business_entityType',*/
      "label_selfAssessment_general_business_other_fields",
    ],
  },
  {
    name: "Snapshot",
    displayName: "Snapshot",
    endpoint: "Snapshots",
    showInMenu: true,
    idName: "id",
    fieldsToShow: [
      "startDate",
      "endDate",
      "selfAssessment_general_business_companyName",
      'status'
    ],
    fields: [
      new FormField("startDate", "", FieldType.DATE_PICKER),
      new FormField("endDate", "", FieldType.DATE_PICKER),
      new FormField("status", "", FieldType.SELECT_LIST, null, null, null, [
        { value: "label_configuration_snapshot_active", text: "Active" },
        {
          value: "label_configuration_snapshot_validation",
          text: "Validation",
        },
        { value: "label_configuration_snapshot_accepted", text: "Accepted" },
      ]),
      new FormField(
        "businessId",
        "",
        FieldType.SELECT,
        "Businesses",
        "id",
        "selfAssessment_general_business_companyName"
      ),
    ],
    ManyToManyRelationships: [],
  },
  {
    name: "Tag",
    displayName: "Tag",
    endpoint: "Tags",
    showInMenu: true,
    idName: "id",
    fieldsToShow: ["name","public","category"],
    fields: [
      new FormField("name", "", FieldType.INPUT),
      new FormField("public", "", FieldType.BOOLEAN),
      new FormField("category", "", FieldType.SELECT_LIST, null, null, null, [
        {
          value: "single",
          text: "Para unica compañia",
        },
        { value: "multiple", text: "Para grupo de empresas" },
      ]),
    ],
    ManyToManyRelationships: [
      new CreateManyToMany(
        "Businesses",
        "id",
        "selfAssessment_general_business_companyName",
        "BusinessTags",
        "tagId",
        "businessId"
      ),
    ],
  },
  {
    name: "Permission",
    endpoint: "Permissions",
    idName: "customId",
    fieldsToShow: ["name"],
    fields: [
      new FormField("name", "", FieldType.INPUT),
      new FormField("description", "", FieldType.INPUT),
      new FormField("public", "", FieldType.INPUT),
    ],
    ManyToManyRelationships: [
      new CreateManyToMany(
        "RoleTypes",
        "id",
        "name",
        "PermissionRoleTypes",
        "permissionId",
        "roleTypeId"
      ),
      new CreateManyToMany(
        "PermissionModules",
        "id",
        "name",
        "PermissionModulePermissions",
        "permissionId",
        "permissionModuleId"
      ),
    ],
  },
  {
    name: "RoleType",
    displayName: "Role Type",
    description:
      "Con el role type podemos definir qué permisos se permitirán asignar a los Tags, Country y Region en el momento de crear la plantilla en el Account role template",
    showInMenu: true,
    endpoint: "RoleTypes",
    idName: "id",
    fieldsToShow: ["name", "description"],
    fields: [
      new FormField("name", "", FieldType.INPUT),
      new FormField("description", "", FieldType.INPUT),
    ],
    ManyToManyRelationships: [
      new CreateManyToMany(
        "Permissions",
        "customId",
        "name",
        "PermissionRoleTypes",
        "roleTypeId",
        "permissionId",
        null,
        "."
      ),
    ],
  },
  {
    name: "PermissionModule",
    endpoint: "PermissionModules",
    idName: "id",
    fieldsToShow: ["name"],
    fields: [
      new FormField("name", "", FieldType.INPUT),
      new FormField("description", "", FieldType.INPUT),
    ],
    ManyToManyRelationships: [
      new CreateManyToMany(
        "Permissions",
        "customId",
        "name",
        "PermissionModulePermissions",
        "permissionModuleId",
        "permissionId"
      ),
    ],
  },
  {
    name: "AccessControlTemplate",
    endpoint: "AccessControlTemplates",
    idName: "id",
    fieldsToShow: ["ruleByRegionId", "accountRoleTemplateId", "permissionId"],
    fields: [
      new FormField(
        "ruleByRegionId",
        "",
        FieldType.SELECT,
        "Regions",
        "id",
        "region"
      ),
      new FormField(
        "accountRoleTemplateId",
        "",
        FieldType.SELECT,
        "AccountRoleTemplates",
        "id",
        "name"
      ),
      new FormField(
        "permissionId",
        "",
        FieldType.SELECT,
        "Permissions",
        "id",
        "name"
      ),
    ],
    ManyToManyRelationships: [],
  },
  {
    name: "AccountRoleTemplate",
    displayName: "Account Role Template",
    description:
      "El account role template permite crear plantillas de permisos para ser aplicadas en la creación de roles. El objetivo del access control template es facilitar la creación de roles basados en Tags, Country y Region.",
    endpoint: "AccountRoleTemplates",
    idName: "id",
    fieldsToShow: ["roleTypeId", "name", "description"],
    fields: [
      new FormField(
        "roleTypeId",
        "",
        FieldType.SELECT,
        "RoleTypes",
        "id",
        "name"
      ),
      new FormField("name", "", FieldType.INPUT),
      new FormField("description", "", FieldType.INPUT),
    ],
    ManyToManyRelationships: [],
  },
];

export function GetTablesNamesForSelector() {
  const tables = ConfigurationTableList.map((table) => {
    return { value: table.name, text: table.name };
  }).sort(function (a, b) {
    if (a.text < b.text) {
      return -1;
    }
    if (a.text > b.text) {
      return 1;
    }
    return 0;
  });
  return tables;
}

export function GetTableDataByName(tableName) {
  const _ = require("lodash");
  return _.cloneDeep(
    ConfigurationTableList.find((table) => table.name === tableName)
  );
}
